/**
 * Maps raw crypto network identifiers returned by the API (e.g. "btc", "erc20")
 * to a friendly, human-readable label (e.g. "BTC Network", "Ethereum (ERC20)").
 * Falls back to uppercasing the raw code + " Network" for anything unmapped.
 *
 * Port of the mobile app's utils/networkHelpers.ts - keep the two in sync.
 */
const NETWORK_LABELS = {
  btc: 'Bitcoin (BTC) Network',
  bitcoin: 'Bitcoin (BTC) Network',
  eth: 'Ethereum (ETH) Network',
  ethereum: 'Ethereum (ETH) Network',
  erc20: 'Ethereum (ERC20)',
  trc20: 'Tron (TRC20)',
  tron: 'Tron (TRC20)',
  bep20: 'BNB Smart Chain (BEP20)',
  bep2: 'BNB Beacon Chain (BEP2)',
  bsc: 'BNB Smart Chain (BEP20)',
  bnb: 'BNB Smart Chain (BEP20)',
  polygon: 'Polygon Network',
  matic: 'Polygon Network',
  ltc: 'Litecoin (LTC) Network',
  litecoin: 'Litecoin (LTC) Network',
  doge: 'Dogecoin (DOGE) Network',
  dogecoin: 'Dogecoin (DOGE) Network',
  xrp: 'Ripple (XRP) Network',
  ripple: 'Ripple (XRP) Network',
  sol: 'Solana (SOL) Network',
  solana: 'Solana (SOL) Network',
  arbitrum: 'Arbitrum Network',
  optimism: 'Optimism Network',
  avax: 'Avalanche (AVAX) Network',
  avalanche: 'Avalanche (AVAX) Network'
}

export function formatNetworkLabel(raw, fallback) {
  if (!raw) return fallback || ''
  const key = String(raw).trim().toLowerCase()
  if (NETWORK_LABELS[key]) return NETWORK_LABELS[key]
  // Unmapped: prefer the provider's own name (e.g. "Binance Smart Chain")
  // when we have one, else uppercase the code and append "Network" so it
  // never renders as a bare lowercase string.
  return fallback || `${String(raw).toUpperCase()} Network`
}

export default { formatNetworkLabel }
